// When you add the time zone here, you need to fix back-end libraries > toolbar.js > IsHoliday
const TimeZones = [
    { name: 'Asia/Ho_Chi_Minh', utcOffset: '+07:00:00'},
    { name: 'Asia/Tokyo', utcOffset: '+09:00:00'},

    // { name: 'Africa/Abidjan', utcOffset: '+00:00:00'},
    // { name: 'Africa/Accra', utcOffset: '+00:00:00'},
    // { name: 'Africa/Addis_Ababa', utcOffset: '+03:00:00'},
    // { name: 'Africa/Algiers', utcOffset: '+01:00:00'},
    // { name: 'Africa/Asmara', utcOffset: '+03:00:00'},
    // { name: 'Africa/Asmera', utcOffset: '+03:00:00'},
    // { name: 'Africa/Bamako', utcOffset: '+00:00:00'},
    // { name: 'Africa/Bangui', utcOffset: '+01:00:00'},
    // { name: 'Africa/Banjul', utcOffset: '+00:00:00'},
    // { name: 'Africa/Bissau', utcOffset: '+00:00:00'},
    // { name: 'Africa/Blantyre', utcOffset: '+02:00:00'},
    // { name: 'Africa/Brazzaville', utcOffset: '+01:00:00'},
    // { name: 'Africa/Bujumbura', utcOffset: '+02:00:00'},
    // { name: 'Africa/Cairo', utcOffset: '+02:00:00'},
    // { name: 'Africa/Casablanca', utcOffset: '+01:00:00'},
    // { name: 'Africa/Ceuta', utcOffset: '+01:00:00'},
    // { name: 'Africa/Conakry', utcOffset: '+00:00:00'},
    // { name: 'Africa/Dakar', utcOffset: '+00:00:00'},
    // { name: 'Africa/Dar_es_Salaam', utcOffset: '+03:00:00'},
    // { name: 'Africa/Djibouti', utcOffset: '+03:00:00'},
    // { name: 'Africa/Douala', utcOffset: '+01:00:00'},
    // { name: 'Africa/El_Aaiun', utcOffset: '+01:00:00'},
    // { name: 'Africa/Freetown', utcOffset: '+00:00:00'},
    // { name: 'Africa/Gaborone', utcOffset: '+02:00:00'},
    // { name: 'Africa/Harare', utcOffset: '+02:00:00'},
    // { name: 'Africa/Johannesburg', utcOffset: '+02:00:00'},
    // { name: 'Africa/Juba', utcOffset: '+02:00:00'},
    // { name: 'Africa/Kampala', utcOffset: '+03:00:00'},
    // { name: 'Africa/Khartoum', utcOffset: '+02:00:00'},
    // { name: 'Africa/Kigali', utcOffset: '+02:00:00'},
    // { name: 'Africa/Kinshasa', utcOffset: '+01:00:00'},
    // { name: 'Africa/Lagos', utcOffset: '+01:00:00'},
    // { name: 'Africa/Libreville', utcOffset: '+01:00:00'},
    // { name: 'Africa/Lome', utcOffset: '+00:00:00'},
    // { name: 'Africa/Luanda', utcOffset: '+01:00:00'},
    // { name: 'Africa/Lubumbashi', utcOffset: '+02:00:00'},
    // { name: 'Africa/Lusaka', utcOffset: '+02:00:00'},
    // { name: 'Africa/Malabo', utcOffset: '+01:00:00'},
    // { name: 'Africa/Maputo', utcOffset: '+02:00:00'},
    // { name: 'Africa/Maseru', utcOffset: '+02:00:00'},
    // { name: 'Africa/Mbabane', utcOffset: '+02:00:00'},
    // { name: 'Africa/Mogadishu', utcOffset: '+03:00:00'},
    // { name: 'Africa/Monrovia', utcOffset: '+00:00:00'},
    // { name: 'Africa/Nairobi', utcOffset: '+03:00:00'},
    // { name: 'Africa/Ndjamena', utcOffset: '+01:00:00'},
    // { name: 'Africa/Niamey', utcOffset: '+01:00:00'},
    // { name: 'Africa/Nouakchott', utcOffset: '+00:00:00'},
    // { name: 'Africa/Ouagadougou', utcOffset: '+00:00:00'},
    // { name: 'Africa/Porto-Novo', utcOffset: '+01:00:00'},
    // { name: 'Africa/Sao_Tome', utcOffset: '+00:00:00'},
    // { name: 'Africa/Timbuktu', utcOffset: '+00:00:00'},
    // { name: 'Africa/Tripoli', utcOffset: '+02:00:00'},
    // { name: 'Africa/Tunis', utcOffset: '+01:00:00'},
    // { name: 'Africa/Windhoek', utcOffset: '+02:00:00'},
    // { name: 'America/Adak', utcOffset: '−10:00:00'},
    // { name: 'America/Anchorage', utcOffset: '−09:00:00'},
    // { name: 'America/Anguilla', utcOffset: '−04:00:00'},
    // { name: 'America/Antigua', utcOffset: '−04:00:00'},
    // { name: 'America/Araguaina', utcOffset: '−03:00:00'},
    // { name: 'America/Argentina/Buenos_Aires', utcOffset: '−03:00:00'},
    // { name: 'America/Argentina/Catamarca', utcOffset: '−03:00:00'},
    // { name: 'America/Argentina/ComodRivadavia', utcOffset: '−03:00:00'},
    // { name: 'America/Argentina/Cordoba', utcOffset: '−03:00:00'},
    // { name: 'America/Argentina/Jujuy', utcOffset: '−03:00:00'},
    // { name: 'America/Argentina/La_Rioja', utcOffset: '−03:00:00'},
    // { name: 'America/Argentina/Mendoza', utcOffset: '−03:00:00'},
    // { name: 'America/Argentina/Rio_Gallegos', utcOffset: '−03:00:00'},
    // { name: 'America/Argentina/Salta', utcOffset: '−03:00:00'},
    // { name: 'America/Argentina/San_Juan', utcOffset: '−03:00:00'},
    // { name: 'America/Argentina/San_Luis', utcOffset: '−03:00:00'},
    // { name: 'America/Argentina/Tucuman', utcOffset: '−03:00:00'},
    // { name: 'America/Argentina/Ushuaia', utcOffset: '−03:00:00'},
    // { name: 'America/Aruba', utcOffset: '−04:00:00'},
    // { name: 'America/Asuncion', utcOffset: '−04:00:00'},
    // { name: 'America/Atikokan', utcOffset: '−05:00:00'},
    // { name: 'America/Atka', utcOffset: '−10:00:00'},
    // { name: 'America/Bahia', utcOffset: '−03:00:00'},
    // { name: 'America/Bahia_Banderas', utcOffset: '−06:00:00'},
    // { name: 'America/Barbados', utcOffset: '−04:00:00'},
    // { name: 'America/Belem', utcOffset: '−03:00:00'},
    // { name: 'America/Belize', utcOffset: '−06:00:00'},
    // { name: 'America/Blanc-Sablon', utcOffset: '−04:00:00'},
    // { name: 'America/Boa_Vista', utcOffset: '−04:00:00'},
    // { name: 'America/Bogota', utcOffset: '−05:00:00'},
    // { name: 'America/Boise', utcOffset: '−07:00:00'},
    // { name: 'America/Buenos_Aires', utcOffset: '−03:00:00'},
    // { name: 'America/Cambridge_Bay', utcOffset: '−07:00:00'},
    // { name: 'America/Campo_Grande', utcOffset: '−04:00:00'},
    // { name: 'America/Cancun', utcOffset: '−05:00:00'},
    // { name: 'America/Caracas', utcOffset: '−04:00:00'},
    // { name: 'America/Catamarca', utcOffset: '−03:00:00'},
    // { name: 'America/Cayenne', utcOffset: '−03:00:00'},
    // { name: 'America/Cayman', utcOffset: '−05:00:00'},
    // { name: 'America/Chicago', utcOffset: '−06:00:00'},
    // { name: 'America/Chihuahua', utcOffset: '−06:00:00'},
    // { name: 'America/Ciudad_Juarez', utcOffset: '−07:00:00'},
    // { name: 'America/Coral_Harbour', utcOffset: '−05:00:00'},
    // { name: 'America/Cordoba', utcOffset: '−03:00:00'},
    // { name: 'America/Costa_Rica', utcOffset: '−06:00:00'},
    // { name: 'America/Creston', utcOffset: '−07:00:00'},
    // { name: 'America/Cuiaba', utcOffset: '−04:00:00'},
    // { name: 'America/Curacao', utcOffset: '−04:00:00'},
    // { name: 'America/Danmarkshavn', utcOffset: '+00:00:00'},
    // { name: 'America/Dawson', utcOffset: '−07:00:00'},
    // { name: 'America/Dawson_Creek', utcOffset: '−07:00:00'},
    // { name: 'America/Denver', utcOffset: '−07:00:00'},
    // { name: 'America/Detroit', utcOffset: '−05:00:00'},
    // { name: 'America/Dominica', utcOffset: '−04:00:00'},
    // { name: 'America/Edmonton', utcOffset: '−07:00:00'},
    // { name: 'America/Eirunepe', utcOffset: '−05:00:00'},
    // { name: 'America/El_Salvador', utcOffset: '−06:00:00'},
    // { name: 'America/Ensenada', utcOffset: '−08:00:00'},
    // { name: 'America/Fort_Nelson', utcOffset: '−07:00:00'},
    // { name: 'America/Fort_Wayne', utcOffset: '−05:00:00'},
    // { name: 'America/Fortaleza', utcOffset: '−03:00:00'},
    // { name: 'America/Glace_Bay', utcOffset: '−04:00:00'},
    // { name: 'America/Godthab', utcOffset: '−02:00:00'},
    // { name: 'America/Goose_Bay', utcOffset: '−04:00:00'},
    // { name: 'America/Grand_Turk', utcOffset: '−05:00:00'},
    // { name: 'America/Grenada', utcOffset: '−04:00:00'},
    // { name: 'America/Guadeloupe', utcOffset: '−04:00:00'},
    // { name: 'America/Guatemala', utcOffset: '−06:00:00'},
    // { name: 'America/Guayaquil', utcOffset: '−05:00:00'},
    // { name: 'America/Guyana', utcOffset: '−04:00:00'},
    // { name: 'America/Halifax', utcOffset: '−04:00:00'},
    // { name: 'America/Havana', utcOffset: '−05:00:00'},
    // { name: 'America/Hermosillo', utcOffset: '−07:00:00'},
    // { name: 'America/Indiana/Indianapolis', utcOffset: '−05:00:00'},
    // { name: 'America/Indiana/Knox', utcOffset: '−06:00:00'},
    // { name: 'America/Indiana/Marengo', utcOffset: '−05:00:00'},
    // { name: 'America/Indiana/Petersburg', utcOffset: '−05:00:00'},
    // { name: 'America/Indiana/Tell_City', utcOffset: '−06:00:00'},
    // { name: 'America/Indiana/Vevay', utcOffset: '−05:00:00'},
    // { name: 'America/Indiana/Vincennes', utcOffset: '−05:00:00'},
    // { name: 'America/Indiana/Winamac', utcOffset: '−05:00:00'},
    // { name: 'America/Indianapolis', utcOffset: '−05:00:00'},
    // { name: 'America/Inuvik', utcOffset: '−07:00:00'},
    // { name: 'America/Iqaluit', utcOffset: '−05:00:00'},
    // { name: 'America/Jamaica', utcOffset: '−05:00:00'},
    // { name: 'America/Jujuy', utcOffset: '−03:00:00'},
    // { name: 'America/Juneau', utcOffset: '−09:00:00'},
    // { name: 'America/Kentucky/Louisville', utcOffset: '−05:00:00'},
    // { name: 'America/Kentucky/Monticello', utcOffset: '−05:00:00'},
    // { name: 'America/Knox_IN', utcOffset: '−06:00:00'},
    // { name: 'America/Kralendijk', utcOffset: '−04:00:00'},
    // { name: 'America/La_Paz', utcOffset: '−04:00:00'},
    // { name: 'America/Lima', utcOffset: '−05:00:00'},
    // { name: 'America/Los_Angeles', utcOffset: '−08:00:00'},
    // { name: 'America/Louisville', utcOffset: '−05:00:00'},
    // { name: 'America/Lower_Princes', utcOffset: '−04:00:00'},
    // { name: 'America/Maceio', utcOffset: '−03:00:00'},
    // { name: 'America/Managua', utcOffset: '−06:00:00'},
    // { name: 'America/Manaus', utcOffset: '−04:00:00'},
    // { name: 'America/Marigot', utcOffset: '−04:00:00'},
    // { name: 'America/Martinique', utcOffset: '−04:00:00'},
    // { name: 'America/Matamoros', utcOffset: '−06:00:00'},
    // { name: 'America/Mazatlan', utcOffset: '−07:00:00'},
    // { name: 'America/Mendoza', utcOffset: '−03:00:00'},
    // { name: 'America/Menominee', utcOffset: '−06:00:00'},
    // { name: 'America/Merida', utcOffset: '−06:00:00'},
    // { name: 'America/Metlakatla', utcOffset: '−09:00:00'},
    // { name: 'America/Mexico_City', utcOffset: '−06:00:00'},
    // { name: 'America/Miquelon', utcOffset: '−03:00:00'},
    // { name: 'America/Moncton', utcOffset: '−04:00:00'},
    // { name: 'America/Monterrey', utcOffset: '−06:00:00'},
    // { name: 'America/Montevideo', utcOffset: '−03:00:00'},
    // { name: 'America/Montreal', utcOffset: '−05:00:00'},
    // { name: 'America/Montserrat', utcOffset: '−04:00:00'},
    // { name: 'America/Nassau', utcOffset: '−05:00:00'},
    // { name: 'America/New_York', utcOffset: '−05:00:00'},
    // { name: 'America/Nipigon', utcOffset: '−05:00:00'},
    // { name: 'America/Nome', utcOffset: '−09:00:00'},
    // { name: 'America/Noronha', utcOffset: '−02:00:00'},
    // { name: 'America/North_Dakota/Beulah', utcOffset: '−06:00:00'},
    // { name: 'America/North_Dakota/Center', utcOffset: '−06:00:00'},
    // { name: 'America/North_Dakota/New_Salem', utcOffset: '−06:00:00'},
    // { name: 'America/Nuuk', utcOffset: '−02:00:00'},
    // { name: 'America/Ojinaga', utcOffset: '−06:00:00'},
    // { name: 'America/Panama', utcOffset: '−05:00:00'},
    // { name: 'America/Pangnirtung', utcOffset: '−05:00:00'},
    // { name: 'America/Paramaribo', utcOffset: '−03:00:00'},
    // { name: 'America/Phoenix', utcOffset: '−07:00:00'},
    // { name: 'America/Port-au-Prince', utcOffset: '−05:00:00'},
    // { name: 'America/Port_of_Spain', utcOffset: '−04:00:00'},
    // { name: 'America/Porto_Acre', utcOffset: '−05:00:00'},
    // { name: 'America/Porto_Velho', utcOffset: '−04:00:00'},
    // { name: 'America/Puerto_Rico', utcOffset: '−04:00:00'},
    // { name: 'America/Punta_Arenas', utcOffset: '−03:00:00'},
    // { name: 'America/Rainy_River', utcOffset: '−06:00:00'},
    // { name: 'America/Rankin_Inlet', utcOffset: '−06:00:00'},
    // { name: 'America/Recife', utcOffset: '−03:00:00'},
    // { name: 'America/Regina', utcOffset: '−06:00:00'},
    // { name: 'America/Resolute', utcOffset: '−06:00:00'},
    // { name: 'America/Rio_Branco', utcOffset: '−05:00:00'},
    // { name: 'America/Rosario', utcOffset: '−03:00:00'},
    // { name: 'America/Santa_Isabel', utcOffset: '−08:00:00'},
    // { name: 'America/Santarem', utcOffset: '−03:00:00'},
    // { name: 'America/Santiago', utcOffset: '−04:00:00'},
    // { name: 'America/Santo_Domingo', utcOffset: '−04:00:00'},
    // { name: 'America/Sao_Paulo', utcOffset: '−03:00:00'},
    // { name: 'America/Scoresbysund', utcOffset: '−01:00:00'},
    // { name: 'America/Shiprock', utcOffset: '−07:00:00'},
    // { name: 'America/Sitka', utcOffset: '−09:00:00'},
    // { name: 'America/St_Barthelemy', utcOffset: '−04:00:00'},
    // { name: 'America/St_Johns', utcOffset: '−03:30:00'},
    // { name: 'America/St_Kitts', utcOffset: '−04:00:00'},
    // { name: 'America/St_Lucia', utcOffset: '−04:00:00'},
    // { name: 'America/St_Thomas', utcOffset: '−04:00:00'},
    // { name: 'America/St_Vincent', utcOffset: '−04:00:00'},
    // { name: 'America/Swift_Current', utcOffset: '−06:00:00'},
    // { name: 'America/Tegucigalpa', utcOffset: '−06:00:00'},
    // { name: 'America/Thule', utcOffset: '−04:00:00'},
    // { name: 'America/Thunder_Bay', utcOffset: '−05:00:00'},
    // { name: 'America/Tijuana', utcOffset: '−08:00:00'},
    // { name: 'America/Toronto', utcOffset: '−05:00:00'},
    // { name: 'America/Tortola', utcOffset: '−04:00:00'},
    // { name: 'America/Vancouver', utcOffset: '−08:00:00'},
    // { name: 'America/Virgin', utcOffset: '−04:00:00'},
    // { name: 'America/Whitehorse', utcOffset: '−07:00:00'},
    // { name: 'America/Winnipeg', utcOffset: '−06:00:00'},
    // { name: 'America/Yakutat', utcOffset: '−09:00:00'},
    // { name: 'America/Yellowknife', utcOffset: '−07:00:00'},
    // { name: 'Antarctica/Casey', utcOffset: '+11:00:00'},
    // { name: 'Antarctica/Davis', utcOffset: '+07:00:00'},
    // { name: 'Antarctica/DumontDUrville', utcOffset: '+10:00:00'},
    // { name: 'Antarctica/Macquarie', utcOffset: '+10:00:00'},
    // { name: 'Antarctica/Mawson', utcOffset: '+05:00:00'},
    // { name: 'Antarctica/McMurdo', utcOffset: '+12:00:00'},
    // { name: 'Antarctica/Palmer', utcOffset: '−03:00:00'},
    // { name: 'Antarctica/Rothera', utcOffset: '−03:00:00'},
    // { name: 'Antarctica/South_Pole', utcOffset: '+12:00:00'},
    // { name: 'Antarctica/Syowa', utcOffset: '+03:00:00'},
    // { name: 'Antarctica/Troll', utcOffset: '+00:00:00'},
    // { name: 'Antarctica/Vostok', utcOffset: '+06:00:00'},
    // { name: 'Arctic/Longyearbyen', utcOffset: '+01:00:00'},
    // { name: 'Asia/Aden', utcOffset: '+03:00:00'},
    // { name: 'Asia/Almaty', utcOffset: '+06:00:00'},
    // { name: 'Asia/Amman', utcOffset: '+03:00:00'},
    // { name: 'Asia/Anadyr', utcOffset: '+12:00:00'},
    // { name: 'Asia/Aqtau', utcOffset: '+05:00:00'},
    // { name: 'Asia/Aqtobe', utcOffset: '+05:00:00'},
    // { name: 'Asia/Ashgabat', utcOffset: '+05:00:00'},
    // { name: 'Asia/Ashkhabad', utcOffset: '+05:00:00'},
    // { name: 'Asia/Atyrau', utcOffset: '+05:00:00'},
    // { name: 'Asia/Baghdad', utcOffset: '+03:00:00'},
    // { name: 'Asia/Bahrain', utcOffset: '+03:00:00'},
    // { name: 'Asia/Baku', utcOffset: '+04:00:00'},
    // { name: 'Asia/Bangkok', utcOffset: '+07:00:00'},
    // { name: 'Asia/Barnaul', utcOffset: '+07:00:00'},
    // { name: 'Asia/Beirut', utcOffset: '+02:00:00'},
    // { name: 'Asia/Bishkek', utcOffset: '+06:00:00'},
    // { name: 'Asia/Brunei', utcOffset: '+08:00:00'},
    // { name: 'Asia/Calcutta', utcOffset: '+05:30:00'},
    // { name: 'Asia/Chita', utcOffset: '+09:00:00'},
    // { name: 'Asia/Choibalsan', utcOffset: '+08:00:00'},
    // { name: 'Asia/Chongqing', utcOffset: '+08:00:00'},
    // { name: 'Asia/Chungking', utcOffset: '+08:00:00'},
    // { name: 'Asia/Colombo', utcOffset: '+05:30:00'},
    // { name: 'Asia/Dacca', utcOffset: '+06:00:00'},
    // { name: 'Asia/Damascus', utcOffset: '+03:00:00'},
    // { name: 'Asia/Dhaka', utcOffset: '+06:00:00'},
    // { name: 'Asia/Dili', utcOffset: '+09:00:00'},
    // { name: 'Asia/Dubai', utcOffset: '+04:00:00'},
    // { name: 'Asia/Dushanbe', utcOffset: '+05:00:00'},
    // { name: 'Asia/Famagusta', utcOffset: '+02:00:00'},
    // { name: 'Asia/Gaza', utcOffset: '+02:00:00'},
    // { name: 'Asia/Harbin', utcOffset: '+08:00:00'},
    // { name: 'Asia/Hebron', utcOffset: '+02:00:00'},
    // { name: 'Asia/Hong_Kong', utcOffset: '+08:00:00'},
    // { name: 'Asia/Hovd', utcOffset: '+07:00:00'},
    // { name: 'Asia/Irkutsk', utcOffset: '+08:00:00'},
    // { name: 'Asia/Istanbul', utcOffset: '+03:00:00'},
    // { name: 'Asia/Jakarta', utcOffset: '+07:00:00'},
    // { name: 'Asia/Jayapura', utcOffset: '+09:00:00'},
    // { name: 'Asia/Jerusalem', utcOffset: '+02:00:00'},
    // { name: 'Asia/Kabul', utcOffset: '+04:30:00'},
    // { name: 'Asia/Kamchatka', utcOffset: '+12:00:00'},
    // { name: 'Asia/Karachi', utcOffset: '+05:00:00'},
    // { name: 'Asia/Kashgar', utcOffset: '+06:00:00'},
    // { name: 'Asia/Kathmandu', utcOffset: '+05:45:00'},
    // { name: 'Asia/Katmandu', utcOffset: '+05:45:00'},
    // { name: 'Asia/Khandyga', utcOffset: '+09:00:00'},
    // { name: 'Asia/Kolkata', utcOffset: '+05:30:00'},
    // { name: 'Asia/Krasnoyarsk', utcOffset: '+07:00:00'},
    // { name: 'Asia/Kuala_Lumpur', utcOffset: '+08:00:00'},
    // { name: 'Asia/Kuching', utcOffset: '+08:00:00'},
    // { name: 'Asia/Kuwait', utcOffset: '+03:00:00'},
    // { name: 'Asia/Macao', utcOffset: '+08:00:00'},
    // { name: 'Asia/Macau', utcOffset: '+08:00:00'},
    // { name: 'Asia/Magadan', utcOffset: '+11:00:00'},
    // { name: 'Asia/Makassar', utcOffset: '+08:00:00'},
    // { name: 'Asia/Manila', utcOffset: '+08:00:00'},
    // { name: 'Asia/Muscat', utcOffset: '+04:00:00'},
    // { name: 'Asia/Nicosia', utcOffset: '+02:00:00'},
    // { name: 'Asia/Novokuznetsk', utcOffset: '+07:00:00'},
    // { name: 'Asia/Novosibirsk', utcOffset: '+07:00:00'},
    // { name: 'Asia/Omsk', utcOffset: '+06:00:00'},
    // { name: 'Asia/Oral', utcOffset: '+05:00:00'},
    // { name: 'Asia/Phnom_Penh', utcOffset: '+07:00:00'},
    // { name: 'Asia/Pontianak', utcOffset: '+07:00:00'},
    // { name: 'Asia/Pyongyang', utcOffset: '+09:00:00'},
    // { name: 'Asia/Qatar', utcOffset: '+03:00:00'},
    // { name: 'Asia/Qostanay', utcOffset: '+06:00:00'},
    // { name: 'Asia/Qyzylorda', utcOffset: '+05:00:00'},
    // { name: 'Asia/Rangoon', utcOffset: '+06:30:00'},
    // { name: 'Asia/Riyadh', utcOffset: '+03:00:00'},
    // { name: 'Asia/Saigon', utcOffset: '+07:00:00'},
    // { name: 'Asia/Sakhalin', utcOffset: '+11:00:00'},
    // { name: 'Asia/Samarkand', utcOffset: '+05:00:00'},
    // { name: 'Asia/Seoul', utcOffset: '+09:00:00'},
    // { name: 'Asia/Shanghai', utcOffset: '+08:00:00'},
    // { name: 'Asia/Singapore', utcOffset: '+08:00:00'},
    // { name: 'Asia/Srednekolymsk', utcOffset: '+11:00:00'},
    // { name: 'Asia/Taipei', utcOffset: '+08:00:00'},
    // { name: 'Asia/Tashkent', utcOffset: '+05:00:00'},
    // { name: 'Asia/Tbilisi', utcOffset: '+04:00:00'},
    // { name: 'Asia/Tehran', utcOffset: '+03:30:00'},
    // { name: 'Asia/Tel_Aviv', utcOffset: '+02:00:00'},
    // { name: 'Asia/Thimbu', utcOffset: '+06:00:00'},
    // { name: 'Asia/Thimphu', utcOffset: '+06:00:00'},
    // { name: 'Asia/Tomsk', utcOffset: '+07:00:00'},
    // { name: 'Asia/Ujung_Pandang', utcOffset: '+08:00:00'},
    // { name: 'Asia/Ulaanbaatar', utcOffset: '+08:00:00'},
    // { name: 'Asia/Ulan_Bator', utcOffset: '+08:00:00'},
    // { name: 'Asia/Urumqi', utcOffset: '+06:00:00'},
    // { name: 'Asia/Ust-Nera', utcOffset: '+10:00:00'},
    // { name: 'Asia/Vientiane', utcOffset: '+07:00:00'},
    // { name: 'Asia/Vladivostok', utcOffset: '+10:00:00'},
    // { name: 'Asia/Yakutsk', utcOffset: '+09:00:00'},
    // { name: 'Asia/Yangon', utcOffset: '+06:30:00'},
    // { name: 'Asia/Yekaterinburg', utcOffset: '+05:00:00'},
    // { name: 'Asia/Yerevan', utcOffset: '+04:00:00'},
    // { name: 'Atlantic/Azores', utcOffset: '−01:00:00'},
    // { name: 'Atlantic/Bermuda', utcOffset: '−04:00:00'},
    // { name: 'Atlantic/Canary', utcOffset: '+00:00:00'},
    // { name: 'Atlantic/Cape_Verde', utcOffset: '−01:00:00'},
    // { name: 'Atlantic/Faeroe', utcOffset: '+00:00:00'},
    // { name: 'Atlantic/Faroe', utcOffset: '+00:00:00'},
    // { name: 'Atlantic/Jan_Mayen', utcOffset: '+01:00:00'},
    // { name: 'Atlantic/Madeira', utcOffset: '+00:00:00'},
    // { name: 'Atlantic/Reykjavik', utcOffset: '+00:00:00'},
    // { name: 'Atlantic/South_Georgia', utcOffset: '−02:00:00'},
    // { name: 'Atlantic/St_Helena', utcOffset: '+00:00:00'},
    // { name: 'Atlantic/Stanley', utcOffset: '−03:00:00'},
    // { name: 'Australia/ACT', utcOffset: '+10:00:00'},
    // { name: 'Australia/Adelaide', utcOffset: '+09:30:00'},
    // { name: 'Australia/Brisbane', utcOffset: '+10:00:00'},
    // { name: 'Australia/Broken_Hill', utcOffset: '+09:30:00'},
    // { name: 'Australia/Canberra', utcOffset: '+10:00:00'},
    // { name: 'Australia/Currie', utcOffset: '+10:00:00'},
    // { name: 'Australia/Darwin', utcOffset: '+09:30:00'},
    // { name: 'Australia/Eucla', utcOffset: '+08:45:00'},
    // { name: 'Australia/Hobart', utcOffset: '+10:00:00'},
    // { name: 'Australia/LHI', utcOffset: '+10:30:00'},
    // { name: 'Australia/Lindeman', utcOffset: '+10:00:00'},
    // { name: 'Australia/Lord_Howe', utcOffset: '+10:30:00'},
    // { name: 'Australia/Melbourne', utcOffset: '+10:00:00'},
    // { name: 'Australia/North', utcOffset: '+09:30:00'},
    // { name: 'Australia/NSW', utcOffset: '+10:00:00'},
    // { name: 'Australia/Perth', utcOffset: '+08:00:00'},
    // { name: 'Australia/Queensland', utcOffset: '+10:00:00'},
    // { name: 'Australia/South', utcOffset: '+09:30:00'},
    // { name: 'Australia/Sydney', utcOffset: '+10:00:00'},
    // { name: 'Australia/Tasmania', utcOffset: '+10:00:00'},
    // { name: 'Australia/Victoria', utcOffset: '+10:00:00'},
    // { name: 'Australia/West', utcOffset: '+08:00:00'},
    // { name: 'Australia/Yancowinna', utcOffset: '+09:30:00'},
    // { name: 'Brazil/Acre', utcOffset: '−05:00:00'},
    // { name: 'Brazil/DeNoronha', utcOffset: '−02:00:00'},
    // { name: 'Brazil/East', utcOffset: '−03:00:00'},
    // { name: 'Brazil/West', utcOffset: '−04:00:00'},
    // { name: 'Canada/Atlantic', utcOffset: '−04:00:00'},
    // { name: 'Canada/Central', utcOffset: '−06:00:00'},
    // { name: 'Canada/Eastern', utcOffset: '−05:00:00'},
    // { name: 'Canada/Mountain', utcOffset: '−07:00:00'},
    // { name: 'Canada/Newfoundland', utcOffset: '−03:30:00'},
    // { name: 'Canada/Pacific', utcOffset: '−08:00:00'},
    // { name: 'Canada/Saskatchewan', utcOffset: '−06:00:00'},
    // { name: 'Canada/Yukon', utcOffset: '−07:00:00'},
    // { name: 'CET', utcOffset: '+01:00:00'},
    // { name: 'Chile/Continental', utcOffset: '−04:00:00'},
    // { name: 'Chile/EasterIsland', utcOffset: '−06:00:00'},
    // { name: 'CST6CDT', utcOffset: '−06:00:00'},
    // { name: 'Cuba', utcOffset: '−05:00:00'},
    // { name: 'EET', utcOffset: '+02:00:00'},
    // { name: 'Egypt', utcOffset: '+02:00:00'},
    // { name: 'Eire', utcOffset: '+01:00:00'},
    // { name: 'EST', utcOffset: '−05:00:00'},
    // { name: 'EST5EDT', utcOffset: '−05:00:00'},
    // { name: 'Etc/GMT', utcOffset: '+00:00:00'},
    // { name: 'Etc/GMT+0', utcOffset: '+00:00:00'},
    // { name: 'Etc/GMT+1', utcOffset: '−01:00:00'},
    // { name: 'Etc/GMT+10', utcOffset: '−10:00:00'},
    // { name: 'Etc/GMT+11', utcOffset: '−11:00:00'},
    // { name: 'Etc/GMT+12', utcOffset: '−12:00:00'},
    // { name: 'Etc/GMT+2', utcOffset: '−02:00:00'},
    // { name: 'Etc/GMT+3', utcOffset: '−03:00:00'},
    // { name: 'Etc/GMT+4', utcOffset: '−04:00:00'},
    // { name: 'Etc/GMT+5', utcOffset: '−05:00:00'},
    // { name: 'Etc/GMT+6', utcOffset: '−06:00:00'},
    // { name: 'Etc/GMT+7', utcOffset: '−07:00:00'},
    // { name: 'Etc/GMT+8', utcOffset: '−08:00:00'},
    // { name: 'Etc/GMT+9', utcOffset: '−09:00:00'},
    // { name: 'Etc/GMT-0', utcOffset: '+00:00:00'},
    // { name: 'Etc/GMT-1', utcOffset: '+01:00:00'},
    // { name: 'Etc/GMT-10', utcOffset: '+10:00:00'},
    // { name: 'Etc/GMT-11', utcOffset: '+11:00:00'},
    // { name: 'Etc/GMT-12', utcOffset: '+12:00:00'},
    // { name: 'Etc/GMT-13', utcOffset: '+13:00:00'},
    // { name: 'Etc/GMT-14', utcOffset: '+14:00:00'},
    // { name: 'Etc/GMT-2', utcOffset: '+02:00:00'},
    // { name: 'Etc/GMT-3', utcOffset: '+03:00:00'},
    // { name: 'Etc/GMT-4', utcOffset: '+04:00:00'},
    // { name: 'Etc/GMT-5', utcOffset: '+05:00:00'},
    // { name: 'Etc/GMT-6', utcOffset: '+06:00:00'},
    // { name: 'Etc/GMT-7', utcOffset: '+07:00:00'},
    // { name: 'Etc/GMT-8', utcOffset: '+08:00:00'},
    // { name: 'Etc/GMT-9', utcOffset: '+09:00:00'},
    // { name: 'Etc/GMT0', utcOffset: '+00:00:00'},
    // { name: 'Etc/Greenwich', utcOffset: '+00:00:00'},
    // { name: 'Etc/UCT', utcOffset: '+00:00:00'},
    // { name: 'Etc/Universal', utcOffset: '+00:00:00'},
    // { name: 'Etc/UTC', utcOffset: '+00:00:00'},
    // { name: 'Etc/Zulu', utcOffset: '+00:00:00'},
    // { name: 'Europe/Amsterdam', utcOffset: '+01:00:00'},
    // { name: 'Europe/Andorra', utcOffset: '+01:00:00'},
    // { name: 'Europe/Astrakhan', utcOffset: '+04:00:00'},
    // { name: 'Europe/Athens', utcOffset: '+02:00:00'},
    // { name: 'Europe/Belfast', utcOffset: '+00:00:00'},
    // { name: 'Europe/Belgrade', utcOffset: '+01:00:00'},
    // { name: 'Europe/Berlin', utcOffset: '+01:00:00'},
    // { name: 'Europe/Bratislava', utcOffset: '+01:00:00'},
    // { name: 'Europe/Brussels', utcOffset: '+01:00:00'},
    // { name: 'Europe/Bucharest', utcOffset: '+02:00:00'},
    // { name: 'Europe/Budapest', utcOffset: '+01:00:00'},
    // { name: 'Europe/Busingen', utcOffset: '+01:00:00'},
    // { name: 'Europe/Chisinau', utcOffset: '+02:00:00'},
    // { name: 'Europe/Copenhagen', utcOffset: '+01:00:00'},
    // { name: 'Europe/Dublin', utcOffset: '+01:00:00'},
    // { name: 'Europe/Gibraltar', utcOffset: '+01:00:00'},
    // { name: 'Europe/Guernsey', utcOffset: '+00:00:00'},
    // { name: 'Europe/Helsinki', utcOffset: '+02:00:00'},
    // { name: 'Europe/Isle_of_Man', utcOffset: '+00:00:00'},
    // { name: 'Europe/Istanbul', utcOffset: '+03:00:00'},
    // { name: 'Europe/Jersey', utcOffset: '+00:00:00'},
    // { name: 'Europe/Kaliningrad', utcOffset: '+02:00:00'},
    // { name: 'Europe/Kiev', utcOffset: '+02:00:00'},
    // { name: 'Europe/Kirov', utcOffset: '+03:00:00'},
    // { name: 'Europe/Kyiv', utcOffset: '+02:00:00'},
    // { name: 'Europe/Lisbon', utcOffset: '+00:00:00'},
    // { name: 'Europe/Ljubljana', utcOffset: '+01:00:00'},
    // { name: 'Europe/London', utcOffset: '+00:00:00'},
    // { name: 'Europe/Luxembourg', utcOffset: '+01:00:00'},
    // { name: 'Europe/Madrid', utcOffset: '+01:00:00'},
    // { name: 'Europe/Malta', utcOffset: '+01:00:00'},
    // { name: 'Europe/Mariehamn', utcOffset: '+02:00:00'},
    // { name: 'Europe/Minsk', utcOffset: '+03:00:00'},
    // { name: 'Europe/Monaco', utcOffset: '+01:00:00'},
    // { name: 'Europe/Moscow', utcOffset: '+03:00:00'},
    // { name: 'Europe/Nicosia', utcOffset: '+02:00:00'},
    // { name: 'Europe/Oslo', utcOffset: '+01:00:00'},
    // { name: 'Europe/Paris', utcOffset: '+01:00:00'},
    // { name: 'Europe/Podgorica', utcOffset: '+01:00:00'},
    // { name: 'Europe/Prague', utcOffset: '+01:00:00'},
    // { name: 'Europe/Riga', utcOffset: '+02:00:00'},
    // { name: 'Europe/Rome', utcOffset: '+01:00:00'},
    // { name: 'Europe/Samara', utcOffset: '+04:00:00'},
    // { name: 'Europe/San_Marino', utcOffset: '+01:00:00'},
    // { name: 'Europe/Sarajevo', utcOffset: '+01:00:00'},
    // { name: 'Europe/Saratov', utcOffset: '+04:00:00'},
    // { name: 'Europe/Simferopol', utcOffset: '+03:00:00'},
    // { name: 'Europe/Skopje', utcOffset: '+01:00:00'},
    // { name: 'Europe/Sofia', utcOffset: '+02:00:00'},
    // { name: 'Europe/Stockholm', utcOffset: '+01:00:00'},
    // { name: 'Europe/Tallinn', utcOffset: '+02:00:00'},
    // { name: 'Europe/Tirane', utcOffset: '+01:00:00'},
    // { name: 'Europe/Tiraspol', utcOffset: '+02:00:00'},
    // { name: 'Europe/Ulyanovsk', utcOffset: '+04:00:00'},
    // { name: 'Europe/Uzhgorod', utcOffset: '+02:00:00'},
    // { name: 'Europe/Vaduz', utcOffset: '+01:00:00'},
    // { name: 'Europe/Vatican', utcOffset: '+01:00:00'},
    // { name: 'Europe/Vienna', utcOffset: '+01:00:00'},
    // { name: 'Europe/Vilnius', utcOffset: '+02:00:00'},
    // { name: 'Europe/Volgograd', utcOffset: '+03:00:00'},
    // { name: 'Europe/Warsaw', utcOffset: '+01:00:00'},
    // { name: 'Europe/Zagreb', utcOffset: '+01:00:00'},
    // { name: 'Europe/Zaporozhye', utcOffset: '+02:00:00'},
    // { name: 'Europe/Zurich', utcOffset: '+01:00:00'},
    // { name: 'Factory', utcOffset: '+00:00:00'},
    // { name: 'GB', utcOffset: '+00:00:00'},
    // { name: 'GB-Eire', utcOffset: '+00:00:00'},
    // { name: 'GMT', utcOffset: '+00:00:00'},
    // { name: 'GMT+0', utcOffset: '+00:00:00'},
    // { name: 'GMT-0', utcOffset: '+00:00:00'},
    // { name: 'GMT0', utcOffset: '+00:00:00'},
    // { name: 'Greenwich', utcOffset: '+00:00:00'},
    // { name: 'Hongkong', utcOffset: '+08:00:00'},
    // { name: 'HST', utcOffset: '−10:00:00'},
    // { name: 'Iceland', utcOffset: '+00:00:00'},
    // { name: 'Indian/Antananarivo', utcOffset: '+03:00:00'},
    // { name: 'Indian/Chagos', utcOffset: '+06:00:00'},
    // { name: 'Indian/Christmas', utcOffset: '+07:00:00'},
    // { name: 'Indian/Cocos', utcOffset: '+06:30:00'},
    // { name: 'Indian/Comoro', utcOffset: '+03:00:00'},
    // { name: 'Indian/Kerguelen', utcOffset: '+05:00:00'},
    // { name: 'Indian/Mahe', utcOffset: '+04:00:00'},
    // { name: 'Indian/Maldives', utcOffset: '+05:00:00'},
    // { name: 'Indian/Mauritius', utcOffset: '+04:00:00'},
    // { name: 'Indian/Mayotte', utcOffset: '+03:00:00'},
    // { name: 'Indian/Reunion', utcOffset: '+04:00:00'},
    // { name: 'Iran', utcOffset: '+03:30:00'},
    // { name: 'Israel', utcOffset: '+02:00:00'},
    // { name: 'Jamaica', utcOffset: '−05:00:00'},
    // { name: 'Japan', utcOffset: '+09:00:00'},
    // { name: 'Kwajalein', utcOffset: '+12:00:00'},
    // { name: 'Libya', utcOffset: '+02:00:00'},
    // { name: 'MET', utcOffset: '+01:00:00'},
    // { name: 'Mexico/BajaNorte', utcOffset: '−08:00:00'},
    // { name: 'Mexico/BajaSur', utcOffset: '−07:00:00'},
    // { name: 'Mexico/General', utcOffset: '−06:00:00'},
    // { name: 'MST', utcOffset: '−07:00:00'},
    // { name: 'MST7MDT', utcOffset: '−07:00:00'},
    // { name: 'Navajo', utcOffset: '−07:00:00'},
    // { name: 'NZ', utcOffset: '+12:00:00'},
    // { name: 'NZ-CHAT', utcOffset: '+12:45:00'},
    // { name: 'Pacific/Apia', utcOffset: '+13:00:00'},
    // { name: 'Pacific/Auckland', utcOffset: '+12:00:00'},
    // { name: 'Pacific/Bougainville', utcOffset: '+11:00:00'},
    // { name: 'Pacific/Chatham', utcOffset: '+12:45:00'},
    // { name: 'Pacific/Chuuk', utcOffset: '+10:00:00'},
    // { name: 'Pacific/Easter', utcOffset: '−06:00:00'},
    // { name: 'Pacific/Efate', utcOffset: '+11:00:00'},
    // { name: 'Pacific/Enderbury', utcOffset: '+13:00:00'},
    // { name: 'Pacific/Fakaofo', utcOffset: '+13:00:00'},
    // { name: 'Pacific/Fiji', utcOffset: '+12:00:00'},
    // { name: 'Pacific/Funafuti', utcOffset: '+12:00:00'},
    // { name: 'Pacific/Galapagos', utcOffset: '−06:00:00'},
    // { name: 'Pacific/Gambier', utcOffset: '−09:00:00'},
    // { name: 'Pacific/Guadalcanal', utcOffset: '+11:00:00'},
    // { name: 'Pacific/Guam', utcOffset: '+10:00:00'},
    // { name: 'Pacific/Honolulu', utcOffset: '−10:00:00'},
    // { name: 'Pacific/Johnston', utcOffset: '−10:00:00'},
    // { name: 'Pacific/Kanton', utcOffset: '+13:00:00'},
    // { name: 'Pacific/Kiritimati', utcOffset: '+14:00:00'},
    // { name: 'Pacific/Kosrae', utcOffset: '+11:00:00'},
    // { name: 'Pacific/Kwajalein', utcOffset: '+12:00:00'},
    // { name: 'Pacific/Majuro', utcOffset: '+12:00:00'},
    // { name: 'Pacific/Marquesas', utcOffset: '−09:30:00'},
    // { name: 'Pacific/Midway', utcOffset: '−11:00:00'},
    // { name: 'Pacific/Nauru', utcOffset: '+12:00:00'},
    // { name: 'Pacific/Niue', utcOffset: '−11:00:00'},
    // { name: 'Pacific/Norfolk', utcOffset: '+11:00:00'},
    // { name: 'Pacific/Noumea', utcOffset: '+11:00:00'},
    // { name: 'Pacific/Pago_Pago', utcOffset: '−11:00:00'},
    // { name: 'Pacific/Palau', utcOffset: '+09:00:00'},
    // { name: 'Pacific/Pitcairn', utcOffset: '−08:00:00'},
    // { name: 'Pacific/Pohnpei', utcOffset: '+11:00:00'},
    // { name: 'Pacific/Ponape', utcOffset: '+11:00:00'},
    // { name: 'Pacific/Port_Moresby', utcOffset: '+10:00:00'},
    // { name: 'Pacific/Rarotonga', utcOffset: '−10:00:00'},
    // { name: 'Pacific/Saipan', utcOffset: '+10:00:00'},
    // { name: 'Pacific/Samoa', utcOffset: '−11:00:00'},
    // { name: 'Pacific/Tahiti', utcOffset: '−10:00:00'},
    // { name: 'Pacific/Tarawa', utcOffset: '+12:00:00'},
    // { name: 'Pacific/Tongatapu', utcOffset: '+13:00:00'},
    // { name: 'Pacific/Truk', utcOffset: '+10:00:00'},
    // { name: 'Pacific/Wake', utcOffset: '+12:00:00'},
    // { name: 'Pacific/Wallis', utcOffset: '+12:00:00'},
    // { name: 'Pacific/Yap', utcOffset: '+10:00:00'},
    // { name: 'Poland', utcOffset: '+01:00:00'},
    // { name: 'Portugal', utcOffset: '+00:00:00'},
    // { name: 'PRC', utcOffset: '+08:00:00'},
    // { name: 'PST8PDT', utcOffset: '−08:00:00'},
    // { name: 'ROC', utcOffset: '+08:00:00'},
    // { name: 'ROK', utcOffset: '+09:00:00'},
    // { name: 'Singapore', utcOffset: '+08:00:00'},
    // { name: 'Turkey', utcOffset: '+03:00:00'},
    // { name: 'UCT', utcOffset: '+00:00:00'},
    // { name: 'Universal', utcOffset: '+00:00:00'},
    // { name: 'US/Alaska', utcOffset: '−09:00:00'},
    // { name: 'US/Aleutian', utcOffset: '−10:00:00'},
    // { name: 'US/Arizona', utcOffset: '−07:00:00'},
    // { name: 'US/Central', utcOffset: '−06:00:00'},
    // { name: 'US/East-Indiana', utcOffset: '−05:00:00'},
    // { name: 'US/Eastern', utcOffset: '−05:00:00'},
    // { name: 'US/Hawaii', utcOffset: '−10:00:00'},
    // { name: 'US/Indiana-Starke', utcOffset: '−06:00:00'},
    // { name: 'US/Michigan', utcOffset: '−05:00:00'},
    // { name: 'US/Mountain', utcOffset: '−07:00:00'},
    // { name: 'US/Pacific', utcOffset: '−08:00:00'},
    // { name: 'US/Samoa', utcOffset: '−11:00:00'},
    // { name: 'UTC', utcOffset: '+00:00:00'},
    // { name: 'W-SU', utcOffset: '+03:00:00'},
    // { name: 'WET', utcOffset: '+00:00:00'},
    // { name: 'Zulu', utcOffset: '+00:00:00'},
]

export default TimeZones;